import React, { useEffect, useState, Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormFeedback,
  Form,
  Input,
  Table,
} from "reactstrap";
import { useParams } from "react-router-dom";
import defaultImage from "../../assets/images/default-profile.png";
import AlertSuccess from "../../components/Alerts/AlertSuccess";
import StyledPagination from "../../components/Common/StyledPagination";
import { getSubAdminsCostCenter } from "../../helpers/api_rombo_helper";
import BreadcrumbLink from "/src/components/Common/BreadcrumbLink";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import i18n from "../../i18n";
import * as Yup from "yup";
import { useFormik } from "formik";
import AlertError from "../../components/Alerts/AlertError";
import { orgId } from "../../constants/utils";
import { Permissions } from "../../constants/enums";
import { UncontrolledTooltip } from "reactstrap";
import Select from "react-select";
import { listStatusUsers } from "../../common/data";
import DeleteSubAdminModal from "./DeleteSubAdminModal";

const ViewSubAdmins = () => {

  const { id } = useParams();
  const dispatch = useDispatch();
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);
 
  const [selectCostCenter, setSelectCostCenter] = useState({ id: id });
  const [isLoading, setLoading] = useState(true);
  const [reloadCostCenterEmployees, setReloadCostCenterEmployees] = useState(false);
  const [showAlertSuccess, setShowAlertSuccess] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [clickSubAdmin, setClickSubAdmin] = useState({});
  const [textHeader, setTextHeader] = useState('')
  const [textBody, setTextBody] = useState('')
  const [infoUser, setInfoUser] = useState({ permissions: [] })
  const [partnerId, setPartnerId] = useState(null);
  const [costCenterId, setCostCenterId] = useState(null);
  const [costCenterName, setCostCenterName] = useState("");
  const [subAdmins, setSubAdmins] = useState([]);
  const [subAdminsPage, setSubAdminsPage] = useState(1);
  const itemsPerPage = 8;

  useEffect(() => {
    document.title = `${i18n.t("ViewSubAdmins")} - ${orgId}`;
  }, [orgId]);

  useEffect(() => {
    getSubAdminsCostCenter()
    getCostCenter()
  }, [reloadCostCenterEmployees, loading]);

  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data)
    }
  }, [data, loading]);

  useEffect(() => {
    fetchSubAdmins();
  }, []);

  useEffect(() => {
    const storedPartnerId = localStorage.getItem('selectedPartnerId');
    const storedCostCenterId = localStorage.getItem('selectedCostCenterId');
    const storedCostCenterName = localStorage.getItem('selectedCostCenterName');
  
    if (storedPartnerId) setPartnerId(parseInt(storedPartnerId));
    if (storedCostCenterId) setCostCenterId(parseInt(storedCostCenterId));
    if (storedCostCenterName) setCostCenterName(storedCostCenterName);
  
    if (storedPartnerId && storedCostCenterId) {
      fetchSubAdmins();
    }
  }, []);

  const getCostCenter = () => {
    let localSelectCostCenter = localStorage.getItem('SelectCostCenter');
    setSelectCostCenter(JSON.parse(localSelectCostCenter));
  }

  const autoformik = useFormik({
    initialValues: {
      name: "",
      email: "",
      services: "",
    },
    validationSchema: Yup.object({
      name: Yup.string(),
      email: Yup.string().email("Invalid email format"),
      services: Yup.number(),
    }),
    onSubmit: (values) => {
    },
  });

  const searchFilters = (val, type) => {
    const filters = {
      name: type === "name" ? val : autoformik.values.name,
      email: type === "email" ? val : autoformik.values.email,
      status: type === "status" ? val : autoformik.values.status,
      size: itemsPerPage,
      page: 1,
      partner_id: partnerId,
    };
  
    getSubAdminsCostCenter(token, filters);
  };  

  useEffect(() => {
    const filters = {
      name: autoformik.values.name,
      email: autoformik.values.email,
      status: autoformik.values.status,
      size: itemsPerPage,
      page: 1,
      partner_id: partnerId,
    };
  
    fetchSubAdmins(filters);
  }, [autoformik.values, partnerId]);  

  const fetchSubAdmins = (filters = opts) => {
    setLoading(true);
  
    const storedPartnerId = localStorage.getItem('selectedPartnerId');
    const storedCostCenterId = localStorage.getItem('selectedCostCenterId');
  
    if (!storedPartnerId || !storedCostCenterId) {
      console.error("Error: Required values n​​ot found in localStorage.");
      setLoading(false);
      return;
    }
  
    setPartnerId(parseInt(storedPartnerId));
    setCostCenterId(parseInt(storedCostCenterId));
  
    const updatedFilters = {
      ...filters,
      partner_id: parseInt(storedPartnerId),
      cost_center_id: id,
    };
  
    getSubAdminsCostCenter(token, updatedFilters)
      .then((response) => {
        setSubAdmins(response.items);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching subAdmins:", error);
        setLoading(false);
      });
  };

  const opts = {
    partner_id: String(partnerId),
    page: subAdminsPage,
    size: itemsPerPage,
  };

  const getPaginatedSubAdmins = () => {
    const start = (subAdminsPage - 1) * itemsPerPage;
    return subAdmins.slice(start, start + itemsPerPage);
  };

  const onClickDelete = (subAdmin) => {
    setClickSubAdmin(subAdmin);
    setDeleteModal(true);
  };
  
  return (
    <Fragment>
      <div className="page-content">
        <BreadcrumbLink title={i18n.t("CostCenter")} link={"/cost-centers"} breadcrumbItem={i18n.t("CostCenter")} />
        <Card>
          <CardBody className="pb-2">
            <Row className="pb-2">
              <Col xs={12} xl={12} md={12} className="pb-2">
                <Row>
                  <Col xxl={9} md={6} xs={12}>
                    <CardTitle className="h4">{costCenterName}</CardTitle>
                  </Col>
                  <Col xxl={12} md={12} xs={12} className="text-end">
                    <Row className="justify-content-end align-items-center g-2">
                      <Col className="col-auto">
                          <Link to={'/cost-centers/sub-admin/' + id} className="btn btn-request fs-11">
                            {i18n.t("AssignSubAdmins")}
                          </Link>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} xl={12} md={6} className="pb-2">
              <div className="request-separator"></div>
                <Form className="row gy-2 gx-3 align-items-center" onSubmit={autoformik.handleSubmit}>
                  <Col xxl={4} md={4} xs={12}>
                    <div className="col-sm-auto">                        
                      <Input
                        type="text"
                        name="name"
                        className="form-control"
                        id="nameInput"
                        placeholder={i18n.t("SearchName")}
                        value={autoformik.values.name}
                        onBlur={autoformik.handleBlur}
                        onChange={(e) => {
                          autoformik.handleChange(e);
                          searchFilters(e.target.value, "name")
                        }}
                        invalid={
                          autoformik.touched.name && autoformik.errors.name ? true : false
                        }
                      />
                      {autoformik.errors.name && autoformik.touched.name && (
                        <FormFeedback type="invalid">
                          {autoformik.errors.name}
                        </FormFeedback>
                      )}
                    </div>
                  </Col>
                  <Col xxl={2} md={2} xs={12}>
                    <div className="col-sm-auto">
                      <Input
                        type="text"
                        name="email"
                        className="form-control"
                        id="emailInput"
                        placeholder={i18n.t("Email")}
                        value={autoformik.values.email}
                        onBlur={autoformik.handleBlur}
                        onChange={(e) => {
                          autoformik.handleChange(e);
                          searchFilters(e.target.value, "email")
                        }}
                        invalid={
                          autoformik.touched.email && autoformik.errors.email ? true : false
                        }
                      />
                      {autoformik.errors.email && autoformik.touched.email && (
                        <FormFeedback type="invalid">
                          {autoformik.errors.email}
                        </FormFeedback>
                      )}
                    </div>
                  </Col>
                  <Col xxl={2} md={2} xs={12}>
                    <Select
                      name="status"
                      placeholder={i18n.t("Status")}
                      options={listStatusUsers}
                      isClearable
                      className="select2-selection"
                      onChange={(selectedOption) => {
                        const statusValue = selectedOption ? selectedOption.value : "";
                        autoformik.setFieldValue("status", statusValue);
                      }}
                    />
                  </Col>
                </Form>
                <div className="table-responsive pt-3">
                  <Table className="table table-responsive border">
                    <thead>
                      <tr>
                        <th className="table-header">#</th>
                        <th className="table-header">{i18n.t("Name")}</th>
                        <th className="table-header">{i18n.t("Email")}</th>
                        <th className="table-header">{i18n.t("Rol")}</th>
                        <th className="table-header">{i18n.t("CostCenter")}</th>
                        <th className="table-header">{i18n.t("Status")}</th>
                        <th className="table-header">{i18n.t("Actions")}</th>
                      </tr>
                    </thead>
                    {
                      isLoading ? null :
                      <tbody>
                      {getPaginatedSubAdmins().map((subAdmin) => (
                        <tr key={subAdmin.id}>
                          <td>
                            <img src={defaultImage} className="avatar-xs rounded-circle" alt="" />
                          </td>
                          <td>{subAdmin.full_name}</td>
                          <td>{subAdmin.email}</td>
                          <td>
                            {subAdmin.roles === "ADMIN" ? i18n.t("IsAdmin") : i18n.t("Supervisor")}
                          </td>
                          <td>{costCenterName}</td>
                          <td>
                            <p className={`bg-${subAdmin.status.toLowerCase()} text-white rounded-2 text-center p-1 fs-10`}>
                              {`${i18n.t(subAdmin.status)}`}
                            </p>
                          </td>
                          <td>
                            <div className="d-flex gap-3">
                              {infoUser.permissions.includes(Permissions.USERS_WRITE) && (
                                <Link to={`/users/edit/${subAdmin.id}`} className="text-success">
                                  <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                  <UncontrolledTooltip placement="top" target="edittooltip">
                                    {i18n.t("Edit")}
                                  </UncontrolledTooltip>
                                </Link>
                              )}
                              {infoUser.permissions.includes(Permissions.USERS_DELETE) && (
                                <Link className="text-danger" onClick={() => onClickDelete(subAdmin)}>
                                  <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                  <UncontrolledTooltip placement="top" target="deletetooltip">
                                    {i18n.t("Eliminated")}
                                  </UncontrolledTooltip>
                                </Link>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    }
                  </Table>
                  {subAdmins.length > itemsPerPage && (
                    <StyledPagination
                      pages={Math.ceil(subAdmins.length / itemsPerPage)}
                      setLoading={setLoading}
                      token={token}
                      viewPaginations={5}
                      listTable={setSubAdminsPage}
                      id={null}
                      methodCustom={(page) => fetchSubAdmins(page)}
                      opts={opts}
                      page={subAdminsPage}
                      total={subAdmins.length}
                      size={itemsPerPage}
                      paginationDiv="col-lg-12"
                      paginationClass="pagination pagination-rounded justify-content-end mt-3 mb-4 pb-1"
                    />
                  )}
                </div>
              </Col>
            </Row>
            <Col xxl={2} md={2} xs={3}>
              <Link to={"/cost-centers"} className="btn btn-go-back">{i18n.t("GoBack")}</Link>
            </Col>
          </CardBody>
        </Card>
        <DeleteSubAdminModal
          isOpen={deleteModal}
          toggle={() => setDeleteModal(false)}
          setDeleteModal={setDeleteModal}
          setShowAlertSuccess={setShowAlertSuccess}
          setTextHeader={setTextHeader}
          setTextBody={setTextBody}
          setErrorAlert={setErrorAlert}
          setErrorAlertMessage={setErrorAlertMessage}
          clickUser={clickSubAdmin}
          costCenterId={id}
          setClickUser={setClickSubAdmin}
          setReloadUsers={setReloadCostCenterEmployees}
          token={token}
          reloadUsers={reloadCostCenterEmployees}
        />
        <AlertSuccess
          showAlertSuccess={showAlertSuccess}
          setShowAlertSuccess={setShowAlertSuccess}
          textHeader={textHeader}
          textBody={textBody}
        />
        <AlertError
          showAlertError={errorAlert}
          setShowAlertError={setErrorAlert}
          textHeader={i18n.t("Error")}
          textBody={errorAlertMessage}
        />
      </div>
    </Fragment>
  )
}

ViewSubAdmins.propTypes = {
  onGetCostCenter: PropTypes.func,
  getCostCenter: PropTypes.func
}

export default ViewSubAdmins;
